import React, { useEffect, useReducer, useState } from 'react'
import cn from 'classnames'

import Search from '../Search/Search'
import Info from '../Info/Info'
import Heading from '../Typography/Heading/Heading'

import InfiniteVariantList from './InfiniteVariantList/InfiniteVariantList'
import { getSearchedResults, pageSearchReducer } from './utils/utils'
import { ModalHeader } from '../Modal/Modal'

export type VariantListModalProps = {
  /**
   *Specifies the name of selected variant.
   */
  selectedVariantName?: string
  /**
   *Lets you fetch the variant list using the API
   */
  fetchVariantList?: Function
  /**
   *Lets you display a variant list display in disbaled state
   */
  isListDisabled?: boolean
  /**
   *Pass an ID that can be used for testing purposes. It is applied as a data attribute(data-test-id).
   */
  testId?: string
  /**
   *Pass onclickHandler to handle click on variant
   */
  onClickHandler?: Function
  /**
   *Pass onBaseClickHandler to handle click on variant
   */
  onBaseClickHandler?: Function
  /**
   *Specifies the name of selected locale of the entry.
   */
  selectedLocaleName?: string
  /**
   *Specifies the name of selected ct of the entry.
   */
  selectedContentTypeName?: string
  /**
  *Specifies the number of variant group that will be fetched in API.
  */
  batchSize?: number
  /**
  *Specifies the total number of variant groups avaialble for an entry.
  */
  totalVariantCount?: number
  /**
 *Specifies all available variant group list caontaining variants in each of them .
 */
  allVariantList?: any[]
  /**
 *Specifies all available variant group list caontaining variants in each of them .
 */
  setVariantName?: Function
  /**
 *Specifies all available variant group list caontaining variants in each of them .
 */
  closeModal?: Function
  /**
*Specifies all available variant group list caontaining variants in each of them .
*/
  variantPills: any[],
  /**
  *Specifies all available variant group list caontaining variants in each of them .
  */
  setVariantPills: Function
  /**
  *Specifies all available variant group list caontaining variants in each of them .
  */
  multiSelectTag: boolean
  /**
  *Specifies all available variant group list caontaining variants in each of them .
  */
  disableNonCreatedVariant?: boolean
}
export const VariantListModal = (props: VariantListModalProps) => {
  const {
    fetchVariantList,
    isListDisabled,
    onClickHandler,
    onBaseClickHandler,
    batchSize,
    setVariantName,
    closeModal,
    selectedLocaleName,
    selectedContentTypeName,
    allVariantList,
    totalVariantCount,
    variantPills,
    setVariantPills,
    multiSelectTag,
    disableNonCreatedVariant
  } = props

  const intialState = {
    searchQuery: '',
    pageNumber: 1
  }
  const [state, dispatch] = useReducer(pageSearchReducer, intialState)
  const { searchQuery, pageNumber } = state
  const [variantListData, setVariantListData]: any = useState(allVariantList || [])
  const [variantTags, setVariantTags] = useState([])

  const isListPage = allVariantList && allVariantList.length ? true : false
  const handleUpdatePageSearchQuery = (newStateValue) => {
    dispatch({ type: 'UPDATE_PAGE_SEARCH_QUERY', payload: newStateValue })
  }
  const handleUpdatePageNumber = (newPageNumber) => {
    dispatch({ type: 'UPDATE_PAGE_NUMBER', payload: newPageNumber })
  }
  const handleOnChange = (value) => {
    if (isListPage) {
      const searchResponse = getSearchedResults(value, allVariantList)
      setVariantListData(searchResponse?.length ? searchResponse : [])
      return
    }
    handleUpdatePageSearchQuery({ searchQuery: value })
  }

  const disabledBodyClassname = cn({ 'VariantList__body--disabled': isListDisabled })
  const clickableBaseclassname = cn({ 'VariantList__base--clickable': onBaseClickHandler })

  const onBaseEntryClickHandler = () => {
    // setVariantName('[Base Entry]')
    closeModal()
    if (onBaseClickHandler) onBaseClickHandler()
  }

  useEffect(() => {
    if (multiSelectTag) setVariantPills(variantTags)
  }, [variantTags?.length])

  useEffect(() => {
    if (multiSelectTag) setVariantTags(variantPills)
  }, [variantPills?.length])

  return (
    <>
      {isListPage && (
        <ModalHeader
          title={
            <div className="info-heading">
              Variant Info <div>{totalVariantCount ? totalVariantCount : allVariantList?.length}</div>
            </div>
          }
          closeModal={closeModal}
        />
      )}
      <div className="VariantList__modal">
        {isListDisabled && (
          <div className="VariantList__warning">
            <Info
              content={
                <ul>
                  <li>
                    <Heading tagName="h5" text={'Base entry is not localized'} />
                  </li>
                  <li>
                    {`save this base entry first to localize it in "${selectedLocaleName}" language, before creating a variant entry in this
                  language.`}
                  </li>
                </ul>
              }
              type="attention"
              testId="cs-variant-non-localizable-warning"
              version="v2"></Info>
          </div>
        )}
        <div className={`VariantList__body ${disabledBodyClassname} `}>
          <div className="VariantList__search">
            <Search
              placeholder="Search variants"
              debounceSearch={true}
              width="auto"
              onChange={handleOnChange}
              onClear={true}
              type="primary"
              version="v2"
              testId="cs-variant-list-search"
              searchButtonVisibility={false}
              tabIndex={isListDisabled ? -1 : 0}
            />
          </div>
          <div className="variantList__wrapper">
            {!isListPage && variantListData.length && !multiSelectTag ? (
              <div
                className={`VariantList__base ${clickableBaseclassname}`}
                onClick={onBaseEntryClickHandler}
                data-test-id="cs-variant-base-entry"
                tabIndex={isListDisabled ? -1 : 0}>
                {'[Base Entry]'}
              </div>
            ) : null}
            <div className="VariantList__items" data-test-id="cs-infinite-variant-list">
              <InfiniteVariantList
                searchQuery={searchQuery}
                handleUpdatePageNumber={handleUpdatePageNumber}
                pageNumber={pageNumber}
                fetchVariantList={fetchVariantList}
                selectedContentTypeName={selectedContentTypeName}
                isListDisabled={isListDisabled}
                onClickHandler={onClickHandler}
                batchSize={batchSize}
                variantListData={variantListData}
                setVariantListData={setVariantListData}
                closeModal={props.closeModal}
                setVariantName={setVariantName}
                isListPage={isListPage}
                variantTags={variantTags}
                setVariantTags={setVariantTags}
                multiSelectTag={multiSelectTag}
                disableNonCreatedVariant={disableNonCreatedVariant}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
